import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SummaryRollupWrapperService {
  private _displayFullValue$ = new BehaviorSubject(false);
  displayFullValue$ = this._displayFullValue$.asObservable();

  setDisplayFullValue(displayFullValue: boolean) {
    this._displayFullValue$.next(displayFullValue);
  }
}
